import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';

import * as actions from './leaderboard-nickname.actions';

@State<string>({
  name: 'leaderboardNicknameState',
  defaults: '',
})
@Injectable()
export class LeaderboardNicknameState {
  @Action(actions.SetLeaderboardNickname)
  SetLeaderboardNickname(store: StateContext<string>, action: actions.SetLeaderboardNickname) {
    store.setState(action.payload.nickname);
  }
}
